import { trpc } from "../main/components/trpc.ts";
import { PropositionLimitsComp } from "./PropositionLimitsComp.js";
import { WeekRulesComp, DayRulesComp } from "./WeekAndDayRulesComp";
import { BlocsMainComp } from "./BlocsMainComp";
import { RecommendationSettingsComp } from "./RecommendationSettingsComp";
export type {
  RulesRecord,
  PropositionLimitsRecord,
} from "cadendar-trpc-server";

const RulesMainComp = () => {
  const rules = trpc.rule.getAll.useQuery().data || null;
  console.log("rules", rules);
  return (
    <div className="p-2">
      <div className="text-2xl">Règles de l'agenda</div>
      <div className="flex flex-col gap-2">
        <WeekRulesComp rules={rules?.weekRules || null} />
        <DayRulesComp rules={rules?.dayRules || null} />
        <PropositionLimitsComp limits={rules?.propositionLimits || null} />
        <BlocsMainComp rules={rules?.blocRules || null} />
        {rules?.recommendationSettings ? (
          <RecommendationSettingsComp settings={rules.recommendationSettings} />
        ) : null}
      </div>
    </div>
  );
};

export default RulesMainComp;
